// extracted by mini-css-extract-plugin
export default {"root":"SurveyAsset_root__akK1i"};